import styled, { css } from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

/* TODO: use the variant prop and remove font styles once we've implemented NuDS Typography 2.0 */

export const StyledTypography = styled(Typography)`
  line-height: 1;
  font-weight: 600;
  letter-spacing: -0.06rem;
  word-break: break-word;
  padding-bottom: 1rem;
  border-bottom: .25rem solid ${nuDSColor('primary')};

  ${breakpointsMedia({
    xs: css`
      font-size: 2rem;
    `,
    md: css`
      font-size: 4rem;
    `,
  })}
`;

StyledTypography.displayName = 'StyledTypography';
